import { createSelector } from '@ngrx/store';
import { InfoPopupDialogState } from './info-popup-dialog.state';
import { selectDialogs } from '../../+store';

/**
 * Selectors für den Info-Popup-Dialog.
 */
export class InfoPopupDialogSelectors {
  private static readonly _slice = createSelector(
    selectDialogs,
    (state): InfoPopupDialogState => state.infoPopupDialog,
  );

  /**
   * Selector für den isOpen-Status.
   */
  public static readonly isOpen = createSelector(
    this._slice,
    (state) => state.isOpen,
  );

  /**
   * Selector für den aktuellen Modus.
   */
  public static readonly mode = createSelector(
    this._slice,
    (state) => state.mode,
  );

  /**
   * Selector für die Vorschau-Daten (nur im Preview-Modus relevant).
   */
  public static readonly previewData = createSelector(
    this._slice,
    (state) => state.previewData,
  );
}
